import {
  Factory,
  ClipboardCheck,
  Palette,
  BadgeIndianRupee,
  Ship,
  Headset,
} from "lucide-react";
import { whyChooseUs } from "@/data/site";
import { IDS } from "@/constants/testIds";
import Reveal from "@/components/site/Reveal";

const iconMap = {
  Factory,
  ClipboardCheck,
  Palette,
  BadgeIndianRupee,
  Ship,
  Headset,
};

export default function WhyChooseUs() {
  return (
    <section
      id="why-us"
      data-testid={IDS.whyUsSection}
      className="relative py-24 sm:py-32 bg-white"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <Reveal className="max-w-2xl">
          <span className="text-xs uppercase tracking-[0.25em] font-semibold text-brand">
            Why Choose Us
          </span>
          <h2 className="mt-4 font-heading text-4xl sm:text-5xl font-bold leading-[1.08] tracking-tight text-ink">
            A partner that makes exports{" "}
            <span className="font-serif-accent italic font-medium text-brand">
              simple.
            </span>
          </h2>
        </Reveal>

        <Reveal className="mt-16">
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-px bg-line rounded-3xl overflow-hidden border border-line">
            {whyChooseUs.map((f) => {
              const Icon = iconMap[f.icon];
              return (
                <div
                  key={f.title}
                  className="group bg-white hover:bg-cream p-8 sm:p-10 transition-colors duration-500"
                >
                  <div className="inline-flex h-12 w-12 items-center justify-center rounded-xl bg-sage text-forest group-hover:bg-brand group-hover:text-white transition-colors duration-500">
                    <Icon className="h-6 w-6" strokeWidth={1.7} />
                  </div>
                  <h3 className="mt-6 font-heading text-xl font-semibold text-ink">
                    {f.title}
                  </h3>
                  <p className="mt-2 text-sm text-mist leading-relaxed">
                    {f.body}
                  </p>
                </div>
              );
            })}
          </div>
        </Reveal>
      </div>
    </section>
  );
}
